import React, { useEffect, useState } from 'react';
import { FaCode, FaUsers, FaRocket, FaLightbulb } from 'react-icons/fa';
import aboutImage from '../../assets/about-image.jpg';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.querySelector('.about-content');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const features = [
    {
      icon: <FaCode />,
      title: 'Expert Development',
      description:
        'Our team of skilled developers uses the latest technologies to build robust, scalable solutions.',
    },
    {
      icon: <FaUsers />,
      title: 'Client-Centric Approach',
      description:
        'We believe in building genuine relationships, understanding your unique goals and brand identity.',
    },
    {
      icon: <FaRocket />,
      title: 'Fast Delivery',
      description:
        'We deliver projects on time without compromising on quality, ensuring your business stays ahead.',
    },
    {
      icon: <FaLightbulb />,
      title: 'Innovative Solutions',
      description:
        'Creative problem-solving and cutting-edge technology to give you a competitive advantage.',
    },
  ];

  return (
    <section className="about-section section" id="about">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">About Us</span>
          <h2>About Redfox Digital: Your Growth Partners in the Digital Age</h2>
          <p>
            At Redfox Digital, we're passionate about helping businesses thrive in the ever-evolving
            digital landscape. We're a team of experienced and enthusiastic technology specialists
            dedicated to crafting results-oriented strategies that propel your brand forward.
          </p>
        </div>

        <div className={`about-content ${isVisible ? 'visible' : ''}`}>
          <div className="about-grid">
            <div className="about-image">
              <img src={aboutImage} alt="About Redfox Digital" />
              <div className="about-image-overlay">
                <div className="play-button">
                  <FaRocket />
                </div>
              </div>
            </div>

            <div className="about-text">
              <div className="about-info">
                <h3>Who We Are:</h3>
                <p>
                  We're more than just a technology company. We're your growth partners.
                  We believe in building genuine relationships with our clients, taking the
                  time to understand your unique goals, target audience, and brand identity.
                  This collaborative approach allows us to develop customized digital solutions
                  that deliver measurable results and a strong return on investment (ROI).
                </p>
              </div>

              <div className="about-info">
                <h3>Our Expertise:</h3>
                <p>
                  Our team consists of seasoned professionals with a comprehensive understanding
                  of the digital technology landscape. We stay ahead of the curve by constantly
                  honing our skills and embracing the latest industry trends. Here's a glimpse
                  into the areas where we excel:
                </p>
              </div>
            </div>
          </div>

          <div className="about-features-grid">
            {features.map((feature, index) => (
              <div
                key={index}
                className="feature-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="about-feature-icon">{feature.icon}</div>
                <div className="about-feature-content">
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
